import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class LegacyNameService {

  constructor(
    private userService: UserService,
    private authService: AuthService,
  ) { }

  public updateName(
    firstname: string,
    lastname: string,
    username?: string,
  ): Promise<void> {
    return this.userService.updateUser(
      username,
      firstname,
      lastname,
    ).then(() => {
      return this.authService.refreshLegacyUser();
    });
  }
}
